export var environment = {
  // 上传路径
  upLoadPath() {
    return `${process.env.VUE_APP_BASE_URL}/admin/operate/uploadBanner`
  },
  // 图片验证码
  verification() {
    const api = `${process.env.VUE_APP_BASE_URL}/api/captcha/index`
    return api
  }
}
export default environment
